import { useState } from 'react';
import { Flex, Subtitle } from './TremorCompat';
import { Button, Icon } from './TremorCompat';
import { checkIdValid } from '../utils/utilities';
import Modal from 'rsuite/Modal';
import Input from 'rsuite/Input';
import { MdOutlineEdit as IconEdit } from 'react-icons/md';
import { COLOURS } from '../styles';
import { getUUID_ForInstaller } from '../utils/deviceState';
import { DebounceAddressSelection } from './DebounceAddressSelection';

export const AddInstaller = ({ open, handleClose }) => {
  const [name, setName] = useState('Installer Name');
  const [idValid, setIdValid] = useState(false);
  const [phone, setPhone] = useState('(xx)xxxxxxxxx');
  const [address, setAddress] = useState('Address');
  const [id, setId] = useState(getUUID_ForInstaller());
  // const [filterByCountryCode, setFilterByCountryCode] = useState('au');
  const [countryCodes, setCountryCodes] = useState(['au', 'ch']);

  const validate = (value) => {
    setName(value);
  };

  const onPlaceSelect = (value) => {
    // if ( value.length)
    // {
    //   setAddress( value[0].formatted)
    // }
  };

  const validateId = (value) => {
    setId(value);
    setIdValid(checkIdValid(value));
  };

  const validatePhone = (value) => {
    setPhone(value);
  };

  return (
    <Modal open={open} onClose={() => handleClose(null)} backdrop="static">
      <Modal.Header closeButton={false}>
        <Modal.Title>
          <Flex justifyContent="start" alignItems="center" className="space-x-1">
            <Icon icon={IconEdit} color={COLOURS.default} />
            <Subtitle color={COLOURS.default}>Add Installer</Subtitle>
          </Flex>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="space-y-3">
          <label style={{ display: 'block' }}>
            <span style={{ display: 'block', marginBottom: 4 }}>ID</span>
            <Input placeholder="Enter a valid ID" maxLength={17} size="sm" value={id} onChange={validateId} />
          </label>
          <label style={{ display: 'block' }}>
            <span style={{ display: 'block', marginBottom: 4 }}>Name</span>
            <Input placeholder="Enter a Installers name" maxLength={30} size="sm" value={name} onChange={validate} />
          </label>
          <label style={{ display: 'block' }}>
            <span style={{ display: 'block', marginBottom: 4 }}>Phone</span>
            <Input
              placeholder="Enter a Installers phone"
              maxLength={30}
              size="sm"
              value={phone}
              onChange={validatePhone}
            />
          </label>
          <DebounceAddressSelection value={address} handleClose={onPlaceSelect}></DebounceAddressSelection>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Flex justifyContent="end" alignItems="center" className="space-x-2">
          {/* <Button color={COLOURS.default} size="sm" onClick={() => handleClose({  })} disabled={!idValid || !valid }>Confirm</Button> */}
          <Button
            color={COLOURS.default}
            size="sm"
            onClick={() => handleClose({ id, name, phone, address })}
            // disabled={!idValid}
          >
            Confirm
          </Button>
          <Button color={COLOURS.default} size="sm" variant="secondary" onClick={() => handleClose(null)}>
            Cancel
          </Button>
        </Flex>
      </Modal.Footer>
    </Modal>
  );
};
